import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/analytics";

export const onAddSwiggyMoneyScreenView = (
    swiggyWalletBalance: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    isSwMoneyBusinessLine?: boolean,
): void => {
    impressionEvent({
        category: SCREEN_NAME.SWIGGY_MONEY_TOPUP_PAGE,
        action: IMPRESSION_ACTIONS.IMPRESSION_SWIGGY_MONEY_ADD_MONEY,
        context: swiggyWalletBalance,
        lastScreen: isSwMoneyBusinessLine ? SCREEN_NAME.SWIGGY_MONEY : SCREEN_NAME.PAYMENT,
    });
};

export const clickPredefinedRechargeAmount = (
    swiggyWalletBalance: string,
    amount: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
    isSwMoneyBusinessLine?: boolean,
): void => {
    clickEvent({
        category: SCREEN_NAME.SWIGGY_MONEY_TOPUP_PAGE,
        action: CLICK_ACTIONS.CLICK_PREDEFINED_RECHARGE_AMOUNT,
        label: amount,
        context: swiggyWalletBalance,
        lastScreen: isSwMoneyBusinessLine ? SCREEN_NAME.SWIGGY_MONEY : SCREEN_NAME.PAYMENT,
    });
};

export const onProceedWithRecharge = (
    amount: string,
    selectionType: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
    isSwMoneyBusinessLine?: boolean,
): void => {
    clickEvent({
        category: SCREEN_NAME.SWIGGY_MONEY_TOPUP_PAGE,
        action: CLICK_ACTIONS.CLICK_PROCEED_WITH_RECHARGE,
        label: amount,
        context: selectionType,
        lastScreen: isSwMoneyBusinessLine ? SCREEN_NAME.SWIGGY_MONEY : SCREEN_NAME.PAYMENT,
    });
};

export const clickRedeemVoucherSwMoney = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.SWIGGY_MONEY_TOPUP_PAGE,
        action: CLICK_ACTIONS.CLICK_SM_REDEEM_NOW,
    });
};
